import { useEffect, useState } from "react";
import { CounterInputV2, InputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";
import { parseUtcDate } from "../../../../utils/date/formatedDate";

interface ITaskFertlizationProps {
  task: ITaskFertilization | undefined;
}

export default function InfoFertilization(task: ITaskFertlizationProps) {
  const [taskFertilization, setTaskFertilization] =
    useState<ITaskFertilization>();
  const hasSkipReason = taskFertilization?.skip_reason != null;

  useEffect(() => {
    setTaskFertilization(task.task);
  }, []);

  return (
    <>
      <div>
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskFertilization?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi iniciada?`} pointed />
        <ButtonYesOrNo
          onlyResult
          optionSelected={hasSkipReason ? "no" : "yes"}
        />
      </div>

      {hasSkipReason ? (
        <MessageBalloon text={`${taskFertilization?.skip_reason}`} answer />
      ) : (
        <>
          {taskFertilization?.suggested?.product_name && (
            <MessageBalloon
              text={taskFertilization?.suggested?.product_name}
              pointed
            />
          )}
          {taskFertilization?.suggested?.kg_per_ha != null && (
            <CounterInputV2
              name="info-fert-kg-ha"
              suffix="kg/ha"
              value={String(taskFertilization?.suggested?.kg_per_ha)}
              disabled
            />
          )}

          <MessageBalloon
            text={`${format(parseUtcDate(taskFertilization?.start_time) || 0, "dd/MM/yyyy - HH:mm")}`}
          />

          <MessageBalloon text={`Informar horímetro inicial`} />
          <CounterInputV2
            name="info-fert-initial-h"
            suffix="h"
            value={Number(taskFertilization?.initial_hour_meter ?? 0)}
            disabled
          />

          <ButtonPressed
            onlyResult
            optionSelected={1}
            value={1}
            text={`Horímetro final`}
          />

          <MessageBalloon
            text={`${format(parseUtcDate(taskFertilization?.end_time) || 0, "dd/MM/yyyy - HH:mm")}`}
          />

          <MessageBalloon text={`Informar horímetro final`} />
          <CounterInputV2
            name="info-fert-final-h"
            suffix="h"
            value={Number(taskFertilization?.final_hour_meter ?? 0)}
            disabled
            />

            <div className="containerQuestion">
              <MessageBalloon
                text={`Foi realizada conforme as especificações?`}
                pointed
              />
              <ButtonYesOrNo
                onlyResult
                optionSelected={taskFertilization?.alternate ? "no" : "yes"}
              />
            </div>

            {taskFertilization?.alternate && (
              <>
                <MessageBalloon
                  text={taskFertilization?.alternate?.product_name}
                  pointed
                />
                <CounterInputV2
                  name="info-fert-kg-ha"
                  suffix="kg/ha"
                  value={String(taskFertilization?.alternate?.kg_per_ha)}
                  disabled
                />
              </>
            )}
        </>
      )}

    </>
  );
}
